import React from "react";
// import styles from "../Home/AboutMe.module.css";
import mestyle from "./Me.module.css";
import profilepic from "./avatar.jpg";

const Me = () => {
  return (
    <div className={mestyle.Main} style={{ paddingBottom: 50 }}>
      <div className={mestyle.w70}>
        <div className={mestyle.Heading}>About Me</div>
        <div className={mestyle.SubHeading}>Welcome to my digital zone. 🌱</div>

        <div className={mestyle.Content}>
          Hey, I'm a software developer from Delhi, India. I have a great
          experience in mobile app development. I started my career as a Native
          android app developer, and currently, I'm working as a hybrid mobile
          app developer using React native.
        </div>

        <div className={mestyle.Content}>
          I have a degree in bachelor of technology from the Biju Patnaik
          University of Technology. I have completed some of the below courses
          from Udemy about React, React Native, Node, Go, and AWS. I have also
          worked with some of the CI CD pipeline tools like Fastlane, Circle CI,
          Bitbucket, and SonarQube.
        </div>
        <div className={mestyle.Content} style={{ marginTop: 20 }}>
          You can contact me at the following platforms. I always appreciate
          meeting new people.
          <ul style={{ marginTop: 20 }}>
            <li>
              <a href="https://github.com/hrusikeshswain">
                <strong>GitHub</strong>
              </a>
            </li>
            <li>
              <a href="https://www.linkedin.com/in/hrusikesh-swain-40a179b1/">
                <strong>Linkedin</strong>
              </a>
            </li>
            <li>
              <a href="https://www.instagram.com/im_hrusikesh/">
                <strong>Instagram</strong>
              </a>
            </li>
            <li>
              <a href="https://about.me/rishiappdeveloper">
                <strong>About Me</strong>
              </a>
            </li>
            <li>
              <a href="https://www.facebook.com/hrusikesh.swain1">
                <strong>Facebook</strong>
              </a>
            </li>
          </ul>
        </div>
      </div>
      <div className={mestyle.w30 + " " + mestyle.EmptySpace}>
        <div className={mestyle.container}>
          <div>Me</div>
          <img
            src="https://github.com/hrusikeshswain/Demo/blob/master/app/profile_01.png?raw=true"
            alt="profile_01"
            className={mestyle.imgcontainer}
          />
        </div>
        <div className={mestyle.container} style={{ marginTop: 30 }}>
          <div>Me</div>
          <img
            src="https://github.com/hrusikeshswain/Demo/blob/master/app/profile_02.png?raw=true"
            alt="profile_02"
            className={mestyle.imgcontainer}
          />
        </div>
        {/* <div
          className={mestyle.container}
          style={{ marginTop: 30, height: "auto" }}
        >
          <a href="/">Some more facts about me</a>
        </div> */}
      </div>
    </div>
  );
};

export default Me;
